import IAssignWhitespacePermissionsRequest from "interfaces/requests/IAssignWhitespacePermissionsRequest";

const initialAssignWhitespacePermissionsRequest = () : IAssignWhitespacePermissionsRequest => ({
  userId: "",
  applicationId: "",
  roleIds: [],
  authorityIds: []
});

export { initialAssignWhitespacePermissionsRequest };
